<template>
  <div class="CompanyProfile">
    <Title :title="title" />
    <div class="container flex flex-wrap">
      <div class="content wow fadeInLeft" data-wow-offset="400" v-html="column[8].content">
<!--        <p>{{$t('about.CompanyProfile[0]')}}</p>-->
<!--        <p>{{$t('about.CompanyProfile[1]')}}</p>-->
<!--        <p>{{$t('about.CompanyProfile[2]')}}</p>-->
<!--        <p>{{$t('about.CompanyProfile[3]')}}</p>-->
      </div>
    </div>
  </div>
</template>

<script>
import {get_column} from "../../../util/lang";
import Title from '../Title/Title.vue'
import { mapState } from "vuex";
export default {
  data() {
    return {
      column: {},
      title: {
        cn: '企业简介',
        en: 'company profile'
      }
    }
  },
  components: {
    Title
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
    })
  },
  methods: {
    get_content() {
      const url = get_column();
      this.$$axios.get(url).then(res => {
        this.column = res.data
      })
    },
  },
  created() {
    this.get_content()

  },

}
</script>

<style scoped>
.CompanyProfile .container{
  max-width: 1500px;
  margin: 0 auto;
  padding: 50px 0;
  flex-wrap: wrap;
}
.CompanyProfile .container .content{
  width: 100%;
  font-size: 14px;
  color: #1e1e1e;
  line-height: 40px;
  word-break: break-all;
}
.CompanyProfile .container .video{
  width: 44.8%;
  margin-left: 3.2%;
}
.CompanyProfile .container .video video{
  display: block;
  width: 100%;
}
@media (max-width: 1600px){
  .CompanyProfile .container {
    width: 90%;
  }
}
@media (max-width: 768px){

  .CompanyProfile .container{
    padding: 10px 0;
  }
  .CompanyProfile .container .content,
  .CompanyProfile .container .video{
    width: 100%;
    margin-left: 0;
  }
  .CompanyProfile .container .content{
    padding: 0;
  }
  .CompanyProfile .container .video img{
    width: 100%;
  }
}
</style>


